module.exports = __webpack_public_path__ + "static/media/placeholder.2b2baf1a.jpg";